const PLUGIN_NAME = 'list-query-variables-plugin';

export { PLUGIN_NAME };
